import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { config } from '@xingternal/hops';
import { PrimaryButton, TertiaryButton } from '@xingternal/malt-button';

import TwoFactorAuthAppImage from './../../../Components/Illustrations/TwoFactorAuthAppImage';
import PageviewTracker from './../../../Components/PageviewTracker/PageviewTracker';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';

import parseQueryString from '../../../utils/parseQueryString';
import snakecaseKeys from '../../../utils/snakecaseKeys';
import api from '../../../utils/api';

import styles from './styles.css';
import messages from './messages';

const AdvertiseTwoFactorAuth = ({ toLogin, location: { search } }) => {
  const [isCtaLoading, setIsCtaLoading] = useState(false);
  const [isSkipLoading, setIsSkipLoading] = useState(false);

  const handleCtaClick = e => {
    e.preventDefault();
    setIsCtaLoading(true);

    const windowQuery = parseQueryString(search);
    const queryObject = snakecaseKeys({
      ...windowQuery,
      destUrl: `${config.externalUrl}/settings/account/credentials/twofa`,
    });

    api
      .post('/login/acknowledge_post_login', queryObject)
      .then(({ target }) => {
        if (target) {
          window.location = target;
        }
      })
      .catch(err => {
        console.error(err);

        setIsCtaLoading(false);
        toLogin();
      });
  };

  const handleSkipClick = e => {
    e.preventDefault();
    setIsSkipLoading(true);

    const queryObject = snakecaseKeys(parseQueryString(search));

    api
      .post('/login/acknowledge_post_login', queryObject)
      .then(({ target }) => {
        if (target) {
          window.location = target;
        }
      })
      .catch(err => {
        console.error(err);

        setIsSkipLoading(false);
        toLogin();
      });
  };

  return (
    <React.Fragment>
      <PageviewTracker pageName={'wbm/Welcome/login/account/tfa'} />
      <TwoFactorAuthAppImage />
      <CustomH>
        <FormattedMessage {...messages.advertiseTfaTitle} />
      </CustomH>
      <CustomP>
        <FormattedMessage {...messages.advertiseTfaSubTitle} />
      </CustomP>
      <CustomP>
        <FormattedMessage {...messages.advertiseTfaParagraph} />
      </CustomP>
      <div className={styles.buttonContainer}>
        <TertiaryButton
          className={styles.containerButton}
          loading={isSkipLoading}
          onClick={handleSkipClick}
        >
          <FormattedMessage {...messages.advertiseTfaSkipButtonText} />
        </TertiaryButton>
        <PrimaryButton
          className={styles.containerButton}
          loading={isCtaLoading}
          onClick={handleCtaClick}
        >
          <FormattedMessage {...messages.advertiseTfaButtonText} />
        </PrimaryButton>
      </div>
    </React.Fragment>
  );
};

export default withRouter(AdvertiseTwoFactorAuth);
